import { artCars } from './data/cars';

/**
 * Format a date into a standard format
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (date) => {
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric', 
    year: 'numeric' 
  });
};

/**
 * Extract car number from string like "#1 Alexander Calder"
 * @param {string} carString - The car string to parse
 * @returns {string|null} The car number or null if not found
 */
export const getCarNumber = (carString) => {
  if (carString.includes("TBA")) return null;
  const match = carString.match(/#(\d+)/);
  return match ? `#${match[1]}` : null;
};

/**
 * Get artist info from car number
 * @param {string} carString - The car string to get info for
 * @returns {Object|null} Car info object or null if not found
 */
export const getArtistInfo = (carString) => {
  const carNumber = getCarNumber(carString);
  return carNumber && artCars[carNumber] ? artCars[carNumber] : null;
};